import Vue from 'vue'
import types from '../types'

const state = {
    items: { },
    errorCode: 200
}

const mutations = {
    [types.api.mutations.push] (state, { key }) {
        Vue.set(state.items, key, true)
    },
    [types.api.mutations.pop] (state, { key }) {
        Vue.delete(state.items, key)
    },
    [types.api.mutations.errorCode] (state, { errorCode }) {
        state.errorCode = errorCode
    }
}

const actions = {
    [types.api.actions.push] ({ commit }, { key }) {
        commit(types.api.mutations.push, { key })
    },
    [types.api.actions.pop] ({ commit }, { key }) {
        commit(types.api.mutations.pop, { key })
    },
    [types.api.actions.errorCode] ({ commit, dispatch }, { errorCode }) {
        if (errorCode === 401) {
            dispatch(types.sign.actions.logout)
        }

        commit(types.api.mutations.errorCode, {errorCode})
    }
}

const getters = {
    [types.api.getters.apiState]: state => state.state,
    [types.api.getters.isRunning]: state => Object.keys(state.items).length > 0,
    [types.api.getters.errorCode]: state => state.errorCode || 200
}

export default {
    state,
    mutations,
    actions,
    getters
}
